import { render, staticRenderFns } from "./product-content.vue?vue&type=template&id=d75853e6"
import script from "./product-content.vue?vue&type=script&lang=js"
export * from "./product-content.vue?vue&type=script&lang=js"
import style0 from "./product-content.vue?vue&type=style&index=0&id=d75853e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
